// @ts-nocheck
// get reported issues of a position...
export const GET_REPORTED_ISSUES_OF_POSITION_REQUEST =
  "GET_REPORTED_ISSUES_OF_POSITION_REQUEST";
export const GET_REPORTED_ISSUES_OF_POSITION_SUCCESS =
  "GET_REPORTED_ISSUES_OF_POSITION_SUCCESS";
export const GET_REPORTED_ISSUES_OF_POSITION_FAILURE =
  "GET_REPORTED_ISSUES_OF_POSITION_FAILURE";

// get reported issues by contractor id...
export const GET_REPORTED_ISSUES_BY_CONTRACTOR_ID_REQUEST =
  "GET_REPORTED_ISSUES_BY_CONTRACTOR_ID_REQUEST";
export const GET_REPORTED_ISSUES_BY_CONTRACTOR_ID_SUCCESS =
  "GET_REPORTED_ISSUES_BY_CONTRACTOR_ID_SUCCESS";
export const GET_REPORTED_ISSUES_BY_CONTRACTOR_ID_FAILURE =
  "GET_REPORTED_ISSUES_BY_CONTRACTOR_ID_FAILURE";

// send admin response for reported issue...
export const SEND_ADMIN_RESPONSE_FOR_ISSUE_REQUEST =
  "SEND_ADMIN_RESPONSE_FOR_ISSUE_REQUEST";
export const SEND_ADMIN_RESPONSE_FOR_ISSUE_SUCCESS =
  "SEND_ADMIN_RESPONSE_FOR_ISSUE_SUCCESS";
export const SEND_ADMIN_RESPONSE_FOR_ISSUE_FAILURE =
  "SEND_ADMIN_RESPONSE_FOR_ISSUE_FAILURE";

// add issue for position...
export const ADD_ISSUE_FOR_POSITION_REQUEST = "ADD_ISSUE_FOR_POSITION_REQUEST";
export const ADD_ISSUE_FOR_POSITION_SUCCESS = "ADD_ISSUE_FOR_POSITION_SUCCESS";
export const ADD_ISSUE_FOR_POSITION_FAILURE = "ADD_ISSUE_FOR_POSITION_FAILURE";

// upload media file
export const UPLOAD_MEDIA_FILE_REQUEST = "UPLOAD_MEDIA_FILE_REQUEST";
export const UPLOAD_MEDIA_FILE_SUCCESS = "UPLOAD_MEDIA_FILE_SUCCESS";
export const UPLOAD_MEDIA_FILE_FAILURE = "UPLOAD_MEDIA_FILE_FAILURE";

// get event media files
export const GET_EVENT_MEDIA_FILES_REQUEST = "GET_EVENT_MEDIA_FILES_REQUEST";
export const GET_EVENT_MEDIA_FILES_SUCCESS = "GET_EVENT_MEDIA_FILES_SUCCESS";
export const GET_EVENT_MEDIA_FILES_FAILURE = "GET_EVENT_MEDIA_FILES_FAILURE";

// delete media file
export const DELETE_EVENT_MEDIA_FILE_REQUEST =
  "DELETE_EVENT_MEDIA_FILE_REQUEST";
export const DELETE_EVENT_MEDIA_FILE_SUCCESS =
  "DELETE_EVENT_MEDIA_FILE_SUCCESS";
export const DELETE_EVENT_MEDIA_FILE_FAILURE =
  "DELETE_EVENT_MEDIA_FILE_FAILURE";

// get all media files
export const GET_ALL_MEDIA_FILES_REQUEST = "GET_ALL_MEDIA_FILES_REQUEST";
export const GET_ALL_MEDIA_FILES_SUCCESS = "GET_ALL_MEDIA_FILES_SUCCESS";
export const GET_ALL_MEDIA_FILES_FAILURE = "GET_ALL_MEDIA_FILES_FAILURE";

// delete all media file
export const DELETE_ALL_EVENT_MEDIA_FILE_REQUEST =
  "DELETE_ALL_EVENT_MEDIA_FILE_REQUEST";
export const DELETE_ALL_EVENT_MEDIA_FILE_SUCCESS =
  "DELETE_ALL_EVENT_MEDIA_FILE_SUCCESS";
export const DELETE_ALL_EVENT_MEDIA_FILE_FAILURE =
  "DELETE_ALL_EVENT_MEDIA_FILE_FAILURE";